import api, { Apis } from "../api/api";

interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponse {
  token: string;
  user: {
    id: string;
    name: string;
    email: string;
  };
}

export const loginService = async (data: LoginRequest): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>(Apis.auth.login, data);
  return response.data;
};
export const logoutService = async (): Promise<void> => {
  await api.post(Apis.auth.LogOut); // usually logout is POST
};